/* tslint:disable */
import {
  ApprovedProjectVendorPool,
  Worker,
  Project
} from '../index';

declare var Object: any;
export interface ApvpWorkersVmsInterface {
  "LastModifiedById"?: string;
  "CreatedById"?: string;
  "Name"?: string;
  "sfdcId"?: string;
  "CurrencyIsoCode"?: string;
  "APVP_Accounts_VMS__c"?: string;
  "Project_Routing_Profile__c"?: string;
  "Project_Worker_Rating__c"?: number;
  "Worker__c"?: string;
  "Worker_Registration_Status__c"?: string;
  "CreatedDate"?: Date;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  apvpAccount?: ApprovedProjectVendorPool;
  worker?: Worker;
  routingProfile?: Project;
}

export class ApvpWorkersVms implements ApvpWorkersVmsInterface {
  "LastModifiedById": string;
  "CreatedById": string;
  "Name": string;
  "sfdcId": string;
  "CurrencyIsoCode": string;
  "APVP_Accounts_VMS__c": string;
  "Project_Routing_Profile__c": string;
  "Project_Worker_Rating__c": number;
  "Worker__c": string;
  "Worker_Registration_Status__c": string;
  "CreatedDate": Date;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  apvpAccount: ApprovedProjectVendorPool;
  worker: Worker;
  routingProfile: Project;
  constructor(data?: ApvpWorkersVmsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ApvpWorkersVms`.
   */
  public static getModelName() {
    return "ApvpWorkersVms";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ApvpWorkersVms for dynamic purposes.
  **/
  public static factory(data: ApvpWorkersVmsInterface): ApvpWorkersVms{
    return new ApvpWorkersVms(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ApvpWorkersVms',
      plural: 'ApvpWorkersVms',
      path: 'ApvpWorkersVms',
      idName: 'id',
      properties: {
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "APVP_Accounts_VMS__c": {
          name: 'APVP_Accounts_VMS__c',
          type: 'string'
        },
        "Project_Routing_Profile__c": {
          name: 'Project_Routing_Profile__c',
          type: 'string'
        },
        "Project_Worker_Rating__c": {
          name: 'Project_Worker_Rating__c',
          type: 'number'
        },
        "Worker__c": {
          name: 'Worker__c',
          type: 'string'
        },
        "Worker_Registration_Status__c": {
          name: 'Worker_Registration_Status__c',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        apvpAccount: {
          name: 'apvpAccount',
          type: 'ApprovedProjectVendorPool',
          model: 'ApprovedProjectVendorPool',
          relationType: 'belongsTo',
                  keyFrom: 'APVP_Accounts_VMS__c',
          keyTo: 'sfdcId'
        },
        worker: {
          name: 'worker',
          type: 'Worker',
          model: 'Worker',
          relationType: 'belongsTo',
                  keyFrom: 'Worker__c',
          keyTo: 'sfdcId'
        },
        routingProfile: {
          name: 'routingProfile',
          type: 'Project',
          model: 'Project',
          relationType: 'belongsTo',
                  keyFrom: 'Project_Routing_Profile__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
